import { AttributeComparatorType } from 'types/UserFilter'

export const ATTRIBUTE_COMPARATOR_MAP: {
  [T in keyof AttributeComparatorType]: T
} = {
  in: 'in',
  ['not in']: 'not in',
  contains: 'contains',
  is_empty: 'is_empty'
}
